import React from 'react';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const Button: React.FC<ComponentProps> = ({
  disabled,
  children,
  buttonType = 'primary',
  onClick = () => {},
  isLoading = false,
  ...rest
}) => {
  return (
    <Styled.ButtonWrapper
      disabled={disabled || isLoading}
      buttonType={buttonType}
      onClick={onClick}
      {...rest}>
      <Styled.TextWrapper disabled={disabled} buttonType={buttonType}>
        {children}
      </Styled.TextWrapper>
      {isLoading && <Styled.LoadingSpinner />}
    </Styled.ButtonWrapper>
  );
};

export default Button;
